import React from 'react';
import Promotion from './Sidebar/Promotion'
import Articles from './Sidebar/MostPopularArticles/Articles'

const RightSidebar = ({article, fireAmplitude, isScrolled}) => {

  return (
    <div className={`small-2 columns show-for-large-up right-sidebar ${isScrolled ? "scrolled" : ""}`}>
      <Promotion
        fireAmplitude={fireAmplitude}
      />
      <Articles
        article={article}
        fireAmplitude={fireAmplitude}
      />
    </div>
  )
}

export default RightSidebar;